import { createContext } from 'react'

/**
 * Whether the enclosing `MUIDropdown` opted into keyboard navigation. Its items then forward the `autoFocus` and
 * `tabIndex` that MUI's MenuList hands them, which they otherwise drop.
 */
export const MUIDropdownKeyboardContext = createContext(false)
